import React from "react";
import AdminPharmacys from "../components/AdminPharmacys";
const AdminPharmacy = () => {
  return <AdminPharmacys />;
};

export default AdminPharmacy;
